import { api, viacep } from '@/api'

const actions = {
  identify: async ({ commit, rootState }, dataIdentify) => {
    try {
      commit('Checkout/SET_STATUS_GLOBAL_LOADING', true, { root: true })
      commit('Checkout/SET_STATUS_CART_LOADING', true, { root: true })
      const dataIndentifyCart = {
        ...dataIdentify,
        cart: rootState.Cart.hash,
      }

      const {
        data: { data: fetchIdentify },
      } = await api.post('api/v1/step/identify', dataIndentifyCart)
      await commit('Checkout/SET_STEPSDATA', dataIndentifyCart, { root: true })
      const { id, email, telephone, full_name, national_number, country_code, document_number } =
        fetchIdentify
      await commit('SET_CUSTOMER', {
        id,
        email,
        telephone,
        full_name,
        national_number,
        country_code,
        document_number,
      })

      return fetchIdentify
    } catch (error) {
      throw new Error(error)
    } finally {
      commit('Checkout/SET_STATUS_GLOBAL_LOADING', false, { root: true })
      commit('Checkout/SET_STATUS_CART_LOADING', false, { root: true })
    }
  },
  shipping: async ({ state, commit, rootState }, dataShipping) => {
    try {
      commit('Checkout/SET_STATUS_GLOBAL_LOADING', true, { root: true })
      commit('Checkout/SET_STATUS_CART_LOADING', true, { root: true })
      const sendData = {
        ...dataShipping,
      }

      if (state.id) {
        sendData.customer_id = state.id
      }

      if (rootState.Cart.hash) {
        sendData.cart = rootState.Cart.hash
      }

      commit('Checkout/SET_STEPSDATA', sendData, { root: true })
      const {
        data: { data: fetchShipping },
      } = await api.post('api/v1/step/shipping', sendData)
      const {
        postcode,
        address_city,
        address_street,
        address_street_number,
        address_street_district,
        address_street_complement,
        address_state,
      } = fetchShipping

      commit(
        'Customer/SET_CUSTOMER',
        {
          postcode,
          address_city,
          address_street,
          address_street_number,
          address_street_district,
          address_street_complement,
          address_state,
        },
        { root: true }
      )

      return fetchShipping
    } catch (error) {
      throw new Error(error.message)
    } finally {
      commit('Checkout/SET_STATUS_GLOBAL_LOADING', false, { root: true })
      commit('Checkout/SET_STATUS_CART_LOADING', false, { root: true })
    }
  },
  fetchCep: async ({ commit }, cep) => {
    try {
      commit('SET_CONTAINER_LOADING', true, { root: true })
      const { data: cepData } = await viacep.get(`/${cep}/json`)
      return cepData
    } catch (e) {
      return e.data
    } finally {
      commit('SET_CONTAINER_LOADING', false, { root: true })
    }
  },
}

export default actions
